import React from 'react';
import { Alert, Card, CardHeader, EmptyState, Skeleton } from '@opendate-app/setlist';
import BarRow from './BarRow';

const SUBTITLE = 'Tickets sold, by where the buyer came from';
const count = new Intl.NumberFormat('en-US');

export function channelRows(rows = []) {
  const max = rows[0]?.tickets || 0;
  return rows.map((row) => ({ ...row, width: max > 0 ? (row.tickets / max) * 100 : 0 }));
}

function SalesByChannelCard({ data, loading, error, href, showPurchaseCaption }) {
  const rows = channelRows(data?.rows);

  return (
    <Card
      header={(
        <CardHeader
          title={<a href={href} style={{ color: 'inherit' }}>Sales by channel →</a>}
          supportingText={showPurchaseCaption ? `${SUBTITLE} · By purchase date` : SUBTITLE}
        />
      )}
    >
      {loading && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {Array.from({ length: 7 }, (_, i) => <Skeleton key={i} width="100%" height={28} />)}
        </div>
      )}
      {!loading && error && <Alert color="error" title="Couldn't load sales by channel" description="Refresh the page to try again." />}
      {!loading && !error && rows.length === 0 && <EmptyState size="sm" title="No ticket sales in this range" />}
      {!loading && !error && rows.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {rows.map((row) => (
            <BarRow
              key={row.key}
              label={row.label}
              value={count.format(row.tickets)}
              trailing={<span style={{ width: 48, textAlign: 'right', color: 'var(--sl-text-tertiary)' }}>{`${row.pct}%`}</span>}
              width={row.width}
              color="var(--sl-bg-brand-solid)"
            />
          ))}
        </div>
      )}
    </Card>
  );
}

export default SalesByChannelCard;
